import EntitiesPage from '../pages/entities-page.vue'
import OverviewPage from '../pages/overview-page.vue'
import FilingLocatorDocumentsPage from '../pages/filing-locators/[filingLocatorId]/documents/index.vue'

export default [
  {
    path: '/:slug/tax/overview',
    name: 'tax.overview',
    component: OverviewPage,
  },
  {
    path: '/:slug/tax/entities',
    name: 'tax.filing-locators',
    component: EntitiesPage,
    meta: {},
  },
  {
    path: '/:slug/tax/entities',
    name: 'tax.entities',
    component: EntitiesPage,
    meta: {},
  },
  {
    path: '/:slug/tax/filing-locators/:filingLocatorId/documents',
    component: FilingLocatorDocumentsPage,
    name: 'tax.filing-locator.documents',
  },
]
